/**
 * Pure eligibility logic for the admin password-reset action — mirrors the server
 * authz in the manage-user edge function (which remains the source of truth). Decides
 * whether to SHOW the action for a target row and, if shown-but-not-actionable, the
 * disabled reason. Extracted so it can be unit-tested without rendering.
 */
export interface ResetTarget {
  id: string;
  role?: string | null;
  email?: string | null;
  status?: string;
  is_active?: boolean;
}

export interface ResetGuardResult {
  show: boolean;
  disabledReason?: string;
}

export function passwordResetGuard(
  callerRole: string | null | undefined,
  callerId: string | null | undefined,
  t: ResetTarget,
): ResetGuardResult {
  const role = (callerRole || "").toLowerCase();
  if (role !== "superadmin" && role !== "admin") {
    return { show: false };
  }

  const targetRole = (t.role || "").toLowerCase();
  // Admins never act on superadmins (also enforced server-side + by row visibility).
  if (role === "admin" && targetRole === "superadmin") {
    return { show: false };
  }

  if (t.id === callerId) {
    return {
      show: true,
      disabledReason: "Use Security Settings for your own password",
    };
  }
  if (t.status === "Pending") {
    return { show: true, disabledReason: "Pending invitation" };
  }
  if (t.status === "Inactive" || t.is_active === false) {
    return { show: true, disabledReason: "Inactive user" };
  }
  if (!t.email) {
    return { show: true, disabledReason: "No email on file" };
  }
  return { show: true };
}
